import React from "react";
import "./ProductDescription.css"
interface ProductDescriptionProps {
  description: string;
  attributes: { name: string; options: string[] }[];
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ description, attributes }) => {
  return (
    <div className="mt-10 ">
      <h2 className="px-7 w-fit py-2 mb-5 text-4xl font-bold bg-yellow-400 rounded-xl">Description</h2>
      <div className="descriptionContainer" dangerouslySetInnerHTML={{ __html: description }}></div>
      
    </div>
  );
};

export default ProductDescription;
